import main from "../../Assets/main.jpg";
import "./style.css";
import React from "react";
import { Button } from "react-bootstrap";
import { withRouter } from "react-router-dom";

import { Container, Row, Col, Card } from "react-bootstrap";

import one from "../../Assets/head.png";
import two from "../../Assets/two.png";
import three from "../../Assets/three.png";
import four from "../../Assets/four.png";
import ngtv from "./ngtv.mp4";

import cric1 from "../../Assets/cric1.png";
import cric2 from "../../Assets/cric2.png";

class Nexgen extends React.Component {
  state = {};

  render() {
    return (
      <div style={{ textAlign: "center", overflow:"scroll" }} className="test-demo">
        <img src={one} style={{ width: "100%" }}></img>

        <Row style={{ height: "", background: "#ffc400" }}>
          <Col xs={6} md={6}>
            <div className="mobile" style={{ marginTop: "40px" }}>
              <h4>SMARTER WAY TO SHOP</h4>
              <div
                style={{
                  maxWidth: "500px",
                  margin: "auto",
                  textAlign: "left",
                  marginTop: "30px",
                }}
              >
                <p className="mobile">
                  <b>NGTV</b>, a unique e-Commerce Video Platform & State-of-the-art
                  Shopping Experience.
                </p>
                <p className="mobile">
                  Shop costumes and products worn by your favorite celebrities, available
                  for sale or auctions from the Video Content without disrupting
                  the streaming video or by simply going to the shopping section
                  for a complete view of the available merchandise.
                </p>

                <p className="mobile">
                  Embedded with AI/ML Technology, this creative ecommerce
                  enablement will help empower production houses to sell
                  merchandise through their OTT platform subscriber base with
                  user stickiness, ROI and analytics from this new innovative
                  way of shopping.
                </p>
              </div>

              <Button  style={{ background: "black", marginTop: "5px" }} className="mobile">
                LEARN MORE
              </Button>
            </div>
          </Col>

          <Col xs={12} md={6}>
            <video width="80%" style={{ marginTop: "40px" }} controls>
              <source src={ngtv} type="video/mp4"></source>
            </video>
          </Col>
        </Row>

        <img src={two} style={{ width: "100%", overflow:"scroll" }}></img>
        <img src={three} style={{ width: "100%", overflow:"scroll" }}></img>

        <img src={cric2} style={{ width: "100%", overflow:"scroll" }}></img>

        <img src={cric1} style={{ width: "100%", overflow:"scroll" }}></img>
        <img src={four} style={{ width: "100%" , overflow:"scroll"}}></img>
      </div>
    );
  }
}

export default withRouter(Nexgen);
